module.exports = __webpack_public_path__ + "static/media/down-arrow.ae649bdb.svg";